import React, { useEffect, useState } from 'react'
import useStaffList from '../../../../../hooks/useStaffList';
import { useAlert } from '../../../../../context/AlertContext';
import GrievanceImageInput from './GrievanceImageInput';
import GrievanceDocumentInput from './GrievanceDocumentInput';
import grievanceAttachmentServices from '../../grievanceAttachmentServices';
import { CircularProgress } from '@mui/material';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { AttachFile, Photo } from '@mui/icons-material';

function GrievanceAttachment({grievanceDetails}) {
    const {AppAlert} = useAlert();
    const [staffList,getStaffLabel] = useStaffList();
    const [attachmentList,setAttachmentList] = useState("");
    const [loading,setLoadingStatus] = useState(false);

    const getAttachmentList = () =>{
        setLoadingStatus(true);
        grievanceAttachmentServices.getAttachmentByGrievanceId(grievanceDetails.id).then(res=>{
            setAttachmentList(res.data);
        }).catch(error=>{
            AppAlert("Error While Loading Attachments")
        }).finally(()=>{
            setLoadingStatus(false)
        })
    }

    

    return (
        <div className='row mt-3'>
            <hr/>
            <div className='col-md-12'>
                <GrievanceImageInput grievanceId={grievanceDetails.id} callBack={getAttachmentList} />
                <GrievanceDocumentInput grievanceId={grievanceDetails.id} callBack={getAttachmentList} />
            </div>
            <div className='col-md-12'>
                {! attachmentList && <button className='btn btn-outline-primary mt-3' onClick={getAttachmentList}>Show Attachments</button> }
            </div>
            {loading &&
                <div className='col-md-12 text-center'>
                    <CircularProgress />
                </div>
            }
            {attachmentList && !loading &&
                <div className='col-md-12'>
                    { attachmentList.map(attachment=>
                        <div className='card mt-2' key={attachment.id}>
                            {attachment.fileType == 1 && <img src={attachment.url} className="card-img-top" /> }

                            <div className='card-body'>
                                {attachment.fileType == 1 && 
                                    <Link to={attachment.url} ><Photo/> Download Image</Link>
                                }
                                {attachment.fileType == 2 && 
                                    <Link to={attachment.url} ><AttachFile/> Document</Link>
                                }
                            </div>
                            <div className='card-footer'>
                                <span>By</span><span className="blockquote-footer">{getStaffLabel(attachment.userId)} </span>
                                <span>on</span><span className="blockquote-footer">{moment(attachment.created_at).format("LLL")} </span>
                            </div>
                        </div>
                    )}

                    {attachmentList.length === 0 &&
                        <h3>No Attachment Found</h3>
                    }
                </div>
            }
            
        </div>
    )
}

export default GrievanceAttachment